import Clickable from 'atoms/Clickable/Clickable';
import styled from 'styled-components';
import { cssVar } from 'styles/helper';

export const ImageCardHorizontalContainer = styled(Clickable)`
  .arrow-icon > path {
    transition: all 0.3s ease-in-out;
  }

  &:hover {
    .arrow-icon > path {
      stroke: ${cssVar('gray-light-500')};
    }
  }
`;
